import React, { FC, useEffect, useState, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { RootState, useDispatch, useSelector } from 'src/store';
import { pagesReset } from 'src/store/modules/pages';
import modalSlickAlt from 'src/images/modalSlickAlt.png';
import { buttonsReset } from 'src/store/modules/buttons';

import { editCurrentIndex, imageReset } from 'src/store/modules/imageUpload';
import { editTextReset } from 'src/store/modules/editText';
import { useParams } from 'react-router';
import { API, Auth } from 'aws-amplify';
import setInitValue from 'src/utils/setInitValue';
import { changeEnter } from 'src/utils/changeEnter';
import { editUserCompany } from 'src/store/modules/client';
import { trackingReset } from 'src/store/modules/trackings';
import { getFontURL } from 'src/utils/getFontUrl';
import { initTrackingValues } from '../TemplateTracking/AutoModalSlideTracking';

const initViewValues = {
  currentIndex: 0,
  bg: 'color',
  bgImage: {
    background: '',
    multi_image: [
      'https://image.inappmessage.com/sample/defaultGRAYIMAGE.webp',
      'https://image.inappmessage.com/sample/defaultGRAYIMAGE.webp',
      'https://image.inappmessage.com/sample/defaultGRAYIMAGE.webp',
      'https://image.inappmessage.com/sample/defaultGRAYIMAGE.webp',
      'https://image.inappmessage.com/sample/defaultGRAYIMAGE.webp'
    ]
  },
  deeplink: {
    multi_image: [
      'https://www.inappmessage.com/',
      'https://www.inappmessage.com/',
      'https://www.inappmessage.com/',
      'https://www.inappmessage.com/',
      'https://www.inappmessage.com/'
    ]
  },
  bgColor: { background: '#ffffff' },
  radius: { background: 10, multi_image: 16, multi_button: 0 },

  text: {
    title: '2023 F/W NEW ITEMS',
    sub_title:
      '2023 Fall/winter 신상품이 들어왔어요. 올해 겨울 상품을 지금 바로 확인해보세요. 지금 바로 입고된 상품을 확인하세요.'
  },
  fontSize: { title: 1.25, sub_title: 0.75 },
  fontWeight: { title: 700, sub_title: 400 },
  color: { title: '#000000', sub_title: '#000000' },
  fontFamily: { title: 'Roboto', sub_title: 'Roboto' },
  textAlign: { title: 'center', sub_title: 'center' },

  btnText: {
    multi_button: [
      '상품 보러가기 1',
      '상품 보러가기 2',
      '상품 보러가기 3',
      '상품 보러가기 4',
      '상품 보러가기 5'
    ],
    right_button: '닫기',
    left_button: '다시 보지 않기'
  },
  btnFontSize: { multi_button: 1, right_button: 0.875, left_button: 0.875 },
  btnFontWeight: { multi_button: 700, right_button: 500, left_button: 500 },
  btnColor: {
    multi_button: '#ffffff',
    right_button: '#ffffff',
    left_button: '#ffffff'
  },
  btnBgColorR: { multi_button: 0, right_button: 0, left_button: 0 },
  btnBgColorG: { multi_button: 0, right_button: 0, left_button: 0 },
  btnBgColorB: { multi_button: 0, right_button: 0, left_button: 0 },
  btnBgColorA: { multi_button: 1, right_button: 0, left_button: 0 },
  btnFontFamily: {
    multi_button: 'Roboto',
    right_button: 'Roboto',
    left_button: 'Roboto'
  },
  btnAgain: {
    type: 'none',
    left_button: "don't show"
  }
};

const AutoModalSlide: FC<any> = () => {
  const dispatch = useDispatch();
  const sliderRef = useRef<any>(null);
  const currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  const bg = useSelector((state: RootState) => state.imageUpload.bg);
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  const radius = useSelector((state: RootState) => state.imageUpload.radius);

  const text = useSelector((state: RootState) => state.editText.text);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );

  useEffect(() => {
    async function getUserId() {
      try {
        const current = await Auth.currentUserInfo();
        dispatch(editUserCompany(current.attributes['custom:Company']));
      } catch (error) {
        console.log('error');
      }
    }
    getUserId();
  }, []);
  const titleFontURL = getFontURL(fontFamily?.title);
  const subTitleFontURL = getFontURL(fontFamily?.sub_title);
  const multiButtonFontURL = getFontURL(btnFontFamily?.multi_button);
  const rightButtonFontURL = getFontURL(btnFontFamily?.right_button);
  const leftButtonFontURL = getFontURL(btnFontFamily?.left_button);

  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );

          setInitValue(dispatch, customValues);
        }
      } catch (error) {}
    }
    setInitValue(dispatch, { ...initViewValues, ...initTrackingValues });
    onLoad();
    return () => {
      dispatch(buttonsReset());
      dispatch(editTextReset());
      dispatch(imageReset());
      dispatch(pagesReset());
      dispatch(trackingReset());
    };
  }, []);

  const style = `
  @font-face {
    font-family: 'titleFont';
    src: url(${titleFontURL});
    }

  @font-face {
    font-family: 'subTitleFont';
    src: url(${subTitleFontURL});
    }
  @font-face {
    font-family: 'multiButtonFont';
    src: url(${multiButtonFontURL});
    }
  @font-face {
    font-family: 'rightButtonFont';
    src: url(${rightButtonFontURL});
    }
  @font-face {
    font-family: 'leftButtonFont';
    src: url(${leftButtonFontURL});
    }
    
  .root_view {
    width: 100%;
    height: 100%;

    overflow: hidden;
    position: relative;
    background: none;
    
    .background {
      width: 100%;
      height: 100%;

      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, 0.8);
    }
    .center {
      width: 100%;
      padding: 0 38px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
    .modal_wrapper {
      width: 100%;      
      padding: 1rem 0;
      padding-top: 2rem;

      display: flex;
      flex-direction: column;
      gap: 1rem;
      
      border-radius: ${radius?.background}px;
      ${
        bg === 'image'
          ? `background-image: url(${bgImage?.background});`
          : `background: ${bgColor?.background};`
      };

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }

    .slick_wrapper,
    .slick_wrapper .slick-slider,
    .slick_wrapper .slick-list {
      width: 100%;
      height: 12rem;
    }
    .slick_wrapper .slick-list {
      padding: 0 -0.5rem;
    }
    .slick_wrapper .slick-track {
      display: flex;
    }
    .slick_wrapper .slick-slide {
      padding: 0 0.5rem;
    }
    .slick_image_wrapper {
      min-width: 12rem;
      max-width: 12rem;
      min-height: 12rem;
      max-height: 12rem;            
      outline: 0;
      overflow: hidden;
      border-radius: ${radius?.multi_image}px;
    }
    .slick_image_wrapper img {
      width: 100%;
      height: 100%;
      object-fit: cover;      
      border-radius: ${radius?.multi_image}px;
    }

    .contents_box {
      width: 100%;
      padding: 0 1rem;
    }
    .contents_box .title {
      width: 100%;
      height: 3rem;

      display: flex;
      align-items: center;
    }
    .title .title_inner {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      text-align: ${textAlign?.title};
      color: ${color?.title};
      font-size: ${fontSize?.title}rem;
      font-weight: ${fontWeight?.title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.title
        )
          ? fontFamily.title
          : 'titleFont'
      };
    }

    .dot_wrapper {
      margin-top: 1rem;
    }
    .dot_wrapper,
    .dot_wrapper li {
      height: 0.25rem;      
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 1rem;
      list-style-type: none;
    }
    .dot_wrapper button {
      width: 0.25rem;
      height: 0.25rem;

      font-size: 0;
      border: 0;
      outline: 0;
      border-radius: 999px;
      background-color: rgba(0, 0, 0, 0.3);
    }
    .dot_wrapper li.slick-active button {
      background-color: #000;
    }

    .contents_box .sub_title {
      width: 100%;
      height: 4rem;

      display: flex;
      align-items: center;
    }
    .sub_title .sub_title_inner {
      width: 100%;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;

      text-align: ${textAlign?.sub_title};
      color: ${color?.sub_title};
      font-size: ${fontSize?.sub_title}rem;
      font-weight: ${fontWeight?.sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.sub_title
        )
          ? fontFamily.sub_title
          : 'subTitleFont'
      };
    }

    .bar_wrapper {
      height: 0.25rem;
    }

    .btn_wrapper {
      width: 100%;
      padding: 0 1rem;
    }
    .btn_wrapper button {
      width: 100%;
      height: 3rem;
      outline: 0;
      border: 0;

      cursor: pointer;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      font-size: ${btnFontSize?.multi_button}rem;
      font-weight: ${btnFontWeight?.multi_button};
      color: ${btnColor?.multi_button};
      
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_button
        )
          ? btnFontFamily.multi_button
          : 'multiButtonFont'
      };
      border-radius: ${radius?.multi_button}px;
      background-color:rgba(${btnBgColorR?.multi_button},${
    btnBgColorG?.multi_button
  }, ${btnBgColorB?.multi_button}, ${btnBgColorA?.multi_button});
    }

    .bottom_input {
      width: 1.25rem;
      height: 1.25rem;
    }
    .bottom_wrapper {
      height: 1.25rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .bottom_wrapper .style01 {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 0.5rem;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      color: ${btnColor?.left_button};
      font-weight: ${btnFontWeight?.left_button};
      font-size: ${btnFontSize?.left_button}rem;
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.left_button
        )
          ? btnFontFamily.left_button
          : 'leftButtonFont'
      } important!;
      background-color:rgba(${btnBgColorR?.left_button},${
    btnBgColorG?.left_button
  }, ${btnBgColorB?.left_button}, ${btnBgColorA?.left_button});
    }
    .bottom_wrapper .style02 {
      width: 100%;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      text-align: right;
      color: ${btnColor?.right_button};
      font-weight: ${btnFontWeight?.right_button};
      font-size: ${btnFontSize?.right_button}rem;
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.right_button
        )
          ? btnFontFamily.right_button
          : 'rightButtonFont'
      };
      background-color:rgba(${btnBgColorR?.right_button},${
    btnBgColorG?.right_button
  }, ${btnBgColorB?.right_button}, ${btnBgColorA?.right_button});
    }
  
  }
  `;

  useEffect(() => {
    sliderRef.current.slickGoTo(currentIndex);
    // contentsSliderRef.current.slickGoTo(currentIndex);
  }, [currentIndex]);

  const settings = {
    arrows: false,
    dots: true,

    dotsClass: 'dot_wrapper',
    appendDots: dots => <ul id="id_dot_wrapper">{dots}</ul>,
    // autoplay: true,
    // autoplaySpeed: 2500,

    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    speed: 300,
    touchThreshold: 300
  };

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_view">
        <div className="background" />
        <div className="center">
          <div className="modal_wrapper">
            <div className="contents_box">
              <div className="title">
                <div className="title_inner">{changeEnter(text?.title)}</div>
              </div>
              <div className="sub_title">
                <div className="sub_title_inner">
                  {changeEnter(text?.sub_title)}
                </div>
              </div>
            </div>
            <div className="slick_wrapper">
              <Slider
                {...settings}
                ref={sliderRef}
                afterChange={index => {
                  dispatch(editCurrentIndex(index));
                }}
              >
                {bgImage?.multi_image?.map((data: any, idx: number) => (
                  <div key={idx} className="slick_image_wrapper">
                    <img
                      src={data && data !== '' ? data : modalSlickAlt}
                      alt=""
                    />
                  </div>
                ))}
              </Slider>
            </div>
            <div className="bar_wrapper" />
            <div className="btn_wrapper">
              <button>{btnText?.multi_button?.[currentIndex]}</button>
            </div>
          </div>
          <div className="bottom_wrapper">
            <span className="style01">{btnText?.left_button}</span>
            <span className="style02">{btnText?.right_button}</span>
          </div>
        </div>
      </div>
    </>
  );
};
export default AutoModalSlide;
